import script from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__